
import axios from "axios";
import { API_BASE } from "../config";

export const PostFormAction = (method,data,url)=> {
    axios.defaults.baseURL = API_BASE;
    // let token = localStorage.getItem('token');
    // let Authorization = 'Bearer $'+{token};
  return new Promise((resolve) =>{
        axios({
            method,
            url,
            data,
            headers:{
                "Content-type": "multipart/form-data",
            },
        })
        .then((res) =>{
            console.log(res)
            resolve(res.data)
        })
        .catch((err) =>{
            resolve(err?.response?.data || { status: 'failed', message: 'Request failed.' })
        })
  
    }
  )
}
